module.exports = __webpack_public_path__ + "img/bat.a0484295.svg";